const RNDatePicker = {};

export default RNDatePicker;
